module.exports = __webpack_public_path__ + "static/machine-learning-070f4ef058d41e74584316219d7f955a.png";